window.addEventListener( 'DOMContentLoaded', function() {
    /**
     * We presume that all forms are of search type
     * In case the form has a different purpose we through this loop updated
     * the aria-role of that form and set it to role form
     */

    /**
     * BUGFIX TOGGLE
     * CYT-19621 [A11Y-116] Ensure custom controls provide proper textual name, role, and state information
     */
    const formRoleAttributeRemovalToggle = document.documentElement.dataset.formRoleAttributeRemoved;

    document.querySelectorAll("form.validate-form, .post-form" ).forEach(el => {
        if(formRoleAttributeRemovalToggle) {
            el.removeAttribute('role');
        }
    });

    for (let form of document.querySelectorAll("form.prevent-default")) {
        let inputs = form.getElementsByTagName('input');

        for (let input of inputs) {
            let inputText = input.getAttribute("type");

            if (inputText == "text") {
                input.addEventListener("keypress", function(e) {
                    if (e.which == 13 || e.keyCode == 13) {
                        e.preventDefault();
                    }
                });
            }
        }
    }
});
